import React 	from 'react';
import Ground 	from './Ground';
import Element 	from './Element';
import Utils 	from './Utils';

import _ 		from 'lodash';

const { interact } = window;

export default class Canvas extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
		this.onGridClick = this.onGridClick.bind(this);
		this.onGridMouseMove = this.onGridMouseMove.bind(this);
	}

	componentDidMount() {
		interact('.cell', {context: this.grid}).dropzone({
			accept: '.floating-menu .item, .elements-container .element, .size-selector .size',
			ondrop: (event) => {
				const row = parseInt(event.target.getAttribute('data-row'), 10);
				const col = parseInt(event.target.getAttribute('data-col'), 10);
				const obj = Utils.coordsRelative(event.target, this.canvas);
				obj.row  = row;
				obj.col  = col;
				this.props.onGridDrop(obj, event);
			},
			ondragenter: (event) => {
				const row = parseInt(event.target.getAttribute('data-row'), 10);
				const col = parseInt(event.target.getAttribute('data-col'), 10);
				const obj = Utils.coordsRelative(event.target, this.canvas);
				obj.row  = row;
				obj.col  = col;
				this.props.onGridDragEnter(obj, event);
			}
		});
	}

	onGridMouseMove(row, col, event) {
 		const obj = Utils.coordsRelative(event.target, this.canvas);
		obj.row  = row;
		obj.col  = col;
		this.props.onGridMouseMove(obj);
	}

	onGridClick(row, col, event) {
		const obj = Utils.coordsRelative(event.target, this.canvas);
		obj.row  = row;
		obj.col  = col;
		this.props.onGridClick(obj, event);
	}

	render() {

		const selectedElement = this.props.selectedElement;
		const gridSize = 26;
		// const halfBreakpoint = (gridSize / 2) - 1;

		return (
			<div className="canvas" ref={(el) => this.canvas = el }>

				<div className="canvas-bg"></div>
				
				<Ground type={this.props.ground} />

				<div className="grid" ref={el => this.grid = el}>
					{
						_.map(_.range(0, gridSize), (row, rowKey) => {
							let range = _.range(0, gridSize);

							if (rowKey >= 14) {
								let max = gridSize - rowKey + 12;

								if (rowKey % 2 !== 0) {
									max += 1;
								}
								
								range = _.range(0, max);
							}

							const items = _.map(range, (col, colKey) => {

								let className = 'cell';

								if (selectedElement) {
									if (selectedElement.row === row && selectedElement.col === col) {
										className += selectedElement.canDrop ? ' active' : ' disabled';
									}
								}
								
								return (
									<div key={colKey} 
										data-row={row}
										data-col={col}
										className={className}
										onMouseMove={this.onGridMouseMove.bind(this, row, col)}
										onClick={this.onGridClick.bind(this, row, col)}>{row},{col}</div>
								)
								
							});

							return (<div key={rowKey}>{items}</div>)
						})
					}
				</div>

				<img src="img/rampa.png" className="rampa" role="presentation" />
				<img src="img/rampa-1.png" className="rampa-1" role="presentation" />
				<img src="img/rampa-2.png" className="rampa-2" role="presentation" />
				<img src="img/rampa-3.png" className="rampa-3" role="presentation" />
				<img src="img/rampa-4.png" className="rampa-4" role="presentation" />
				
				{
					selectedElement &&
						<Element 
							src={selectedElement.src}
							size={selectedElement.size}
							top={selectedElement.top} 
							left={selectedElement.left}
							visible={selectedElement.canDrop}
							
							cantDrop={!selectedElement.canDrop}
							dragging={true}
							/>
				}

				<div className="elements-container">
					{
						this.props.elements.map((item, key) => {
							return <Element 
										id={item.id} 
										key={item.id} 
										src={item.src} 
										class={(item.class)? item.class : ''} 
										size={item.size}
										space={item.space}
										top={item.top}
										zIndex={10 + Math.ceil(item.col + item.row)}
										left={item.left}
										selected={item.selected}
										visible={true}
										draggedElement={this.props.draggedElement && this.props.draggedElement.id === item.id ? this.props.draggedElement : null}
										onDeleteClick={this.props.deleteElement.bind(this, item)}
										onElementDragStart={this.props.onElementDragStart}
										onElementDragEnd={this.props.onElementDragEnd}
										onClick={this.props.onElementClick.bind(this, item)}
										isFixed={true}
									/>
						})
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Canvas.js